<template>
  <div>

    <sweet-modal blocking :title="$t('vendors_addPerson')" ref="addPerson" class="modal" v-on:close="closeModal">
      <el-form :model="model" status-icon :rules="rules" ref="model">
        <el-row :gutter="20">
          <el-form-item prop="primaryContact">
            <el-switch v-model="model.primaryContact" active-text="Primary Contact"></el-switch>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="firstname">
              <el-input v-model="model.firstname" :label="$t('modal_first_name')" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="lastname">
              <el-input v-model="model.lastname" :label="$t('modal_last_name')" size="mini"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="email">
              <el-input v-model="model.email" :label="$t('modal_email')" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="position">
              <el-input v-model="model.position" label="Position" size="mini"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="display: flex; justify-content: flex-end;">
          <el-col :span="12">
            <el-form-item prop="department">
              <el-input v-model="model.department" label="Department (Business Unit)" size="mini"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="display: flex; justify-content: flex-end;">
          <el-col :span="12">
            <el-form-item prop="isAddressAssigned">
              <el-switch v-model="model.isAddressAssigned" :active-text="$t('modal_address')"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <template v-if="model.isAddressAssigned">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="address">
                <el-input v-model="model.address" size="mini" :label="$t('modal_address_line_1')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="cityId">
                <el-select no-data-text="no data" v-model="model.cityId" @visible-change="loadCityList" :placeholder="$t('modal_city')" size="small" filterable style="width: 100%;">
                  <el-option
                      v-for="item in cityList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="address2">
                <el-input v-model="model.address2" size="mini" :label="$t('modal_address_line_2')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="stateId">
                <el-select no-data-text="no data" v-model="model.stateId" @visible-change="loadStateList" :placeholder="$t('modal_state')" size="small" filterable style="width: 100%;">
                  <el-option
                    v-for="item in stateList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    @click.native="setCity(item)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="address3">
                <el-input v-model="model.address3" size="mini" :label="$t('modal_address_line_3')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="postCode">
                <el-input v-model="model.postCode" size="mini" :label="$t('modal_post_code')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" style="display: flex; justify-content: flex-end;">
            <el-col :span="12">
              <el-form-item prop="countryId">
                <el-select no-data-text="no data" v-model="model.countryId" @visible-change="loadCountryList" :placeholder="$t('modal_country')" size="small" filterable style="width: 100%;">
                  <el-option
                    v-for="item in countryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    @click.native="setState(item)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="workPhone">
              <el-input v-model="model.workPhone" :label="$t('modal_work_phone')" size="mini"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="phone">
              <el-input v-model="model.phone" :label="$t('modal_phone')" size="mini"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="skype">
              <el-input v-model="model.skype" size="mini" :label="$t('modal_skype')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="facebook">
              <el-input v-model="model.facebook" size="mini" :label="$t('modal_facebook')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="linkedIn">
              <el-input v-model="model.linkedIn" size="mini" :label="$t('modal_linkedIn')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('addPerson')">{{$t('general_cancel')}}</el-button>
          <el-button @click="submitForm('model')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

  </div>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  components: {
    SweetModal,
  },
  props: ['addPerson'],
  // watch: {
  //   'model.isAddressAssigned': function (newVal, oldVal) {
  //     this.model.countryId = null
  //     this.model.stateId = null
  //     this.model.cityId = null
  //     this.model.postCode = ''
  //     this.model.address = ''
  //     this.model.address2 = ''
  //     this.model.address3 = ''
  //   },
  // },
  data() {
    return {
      countryList: [],
      stateList: [],
      cityList: [],

      model: {
        firstname: '',
        lastname: '',
        email: '',

        isAddressAssigned: false,
        countryId: null,
        stateId: null,
        cityId: null,
        postCode: '',
        address: '',
        address2: '',
        address3: '',

        workPhone: '',
        phone: '',
        skype: '',
        facebook: '',
        linkedIn: '',
        // TODO new fields
        primaryContact: false,
        position: '',
        department: ''
      },
      rules: {
        firstname: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        lastname: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur'}
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email', message: 'Invalid email' }
        ],
        // Addresses
        countryId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        stateId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        cityId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        postCode: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    closeModal() {
      this.$refs['model'].resetFields();
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    loadList(type, id, arrType) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/country/directories?type=${type}&id=${id}`)
        .then(response => {
          this[arrType] = response.data.list
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    // Address
    loadCountryList(isVisiable) {
      if (isVisiable && this.countryList.length < 2) {
        this.loadList('country', null, 'countryList')
      }
    },
    loadStateList(isVisiable) {
      if (isVisiable && this.stateList.length < 2) {
        this.loadList('state', this.model.countryId, 'stateList')
      }
    },
    loadCityList(isVisiable) {
      if (isVisiable && this.cityList.length < 2) {
        this.loadList('city', this.model.stateId, 'cityList')
      }
    },
    setState(item) {
      this.model.stateId = null
      this.model.cityId = null
      this.stateList = []
      this.cityList = []
    },
    setCity(item) {
      this.model.cityId = null
      this.cityList = []
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.model.isAddressAssigned) {
            this.model.countryId = null
            this.model.stateId = null
            this.model.cityId = null
            this.model.postCode = ''
            this.model.address = ''
            this.model.address2 = ''
            this.model.address3 = ''
          }

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyClientPersons/create?companyId=${this.$route.query.companyId}&companyClientId=${this.$route.query.companyClientId}`, {
              firstname: this.model.firstname,
              lastname: this.model.lastname,
              email: this.model.email,
              primaryContact: this.model.primaryContact,
              position: this.model.position,
              department: this.model.department,

              isAddressAssigned: this.model.isAddressAssigned,
              countryId: this.model.countryId,
              stateId: this.model.stateId,
              cityId: this.model.cityId,
              postCode: this.model.postCode,
              address: this.model.address,
              address2: this.model.address2,
              address3: this.model.address3,

              workPhone: this.model.workPhone,
              mobilePhone: this.model.phone,
              skype: this.model.skype,
              facebook: this.model.facebook,
              linkedin: this.model.linkedIn,
            })
            .then(response => {
              console.log('---', response.data)
              this.$store.dispatch('getRowDataClients')
              this.$refs.addPerson.close()
              this.notification("Success", "Add Persons", "success")
              this.$emit('selected', response.data.companyVendorPersonId)
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}
</style>

